<template>
  <div class="svg-wrap">

    <!-- angle right -->
    <svg v-if="prop(angleRight)" width="6px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 6 10" style="enable-background:new 0 0 6 10;" xml:space="preserve">
      <path fill="#B2D9DB" d="M0,1.4L1.3,0L6,5L4.7,6.3L0,1.4z M1.3,10L0,8.7l4.7-5L6,5L1.3,10z"/>
    </svg>

    <!-- icon rule lines -->
    <svg v-if="prop(iconRuleLines)" class="icon-rule-lines" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1196 25" style="enable-background:new 0 0 1196 25;" xml:space="preserve">
      <path d="M1196,8h-149.5l-6.5-8H696l-9,8h-19l-6,5h19.3L670,23h-17l-3,2h22l13.6-12h363.8l8.9,9.5l-7.7-9.5H1183L1196,8z M691.2,8l6.8-6h341l5.6,6H691.2z" fill="#c89b3c"/>
      <path d="M526,23l-11.3-10H534l-6-5h-19l-9-8H156l-6.5,8H0l13,5h132.5l-7.5,9.3l9.2-9.3h363.8L525,25h21l-3-2H526z M152.1,8l5.9-6h340l7,6H152.1z" fill="#c89b3c"/>
    </svg>

    <!-- icon rule lines - bottom -->
    <svg v-if="prop(iconRuleLinesBottom)" class="icon-rule-lines icon-rule-lines--bottom" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 132.5 6.4" style="enable-background:new 0 0 132.5 6.4;" xml:space="preserve">
      <path d="M132.5,1.3h-25.2l-1-1.3H75.5l-1.4,1.3h-3l-4.8,3.9l-4.8-3.9h-3L57,0H26.2l-1,1.3H0l2.3,0.9h22.3L23.2,4l1.7-1.7h33.8 l2.4,2.2H63L62.4,4h-1.1l-1.9-1.8h1.7l5.1,4.2l5.2-4.2h1.7L71.2,4h-1.1l-0.6,0.4h1.9l2.4-2.2h33.8l1.7,1.7L108,2.2h22.3L132.5,1.3z M25.8,1.3l0.8-0.8h30.1l0.9,0.8H25.8z M74.8,1.3l0.9-0.8h30.2l0.8,0.8H74.8z" fill="#c89b3c"/>
    </svg>

    <!-- overview-subhead-rule -->
    <svg v-if="prop(overviewSubheadRule)" class="overview-subhead-rule" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 20.91" width="200px" height="21px">
      <polygon fill="#d1a856" points="192.6 9.51 161.87 9.51 163.65 7.71 181.6 7.71 181.28 7.14 163.41 7.14 161.06 9.51 114.77 9.51 113.62 10.66 159.93 10.66 157.41 13.19 111.08 13.19 110.51 13.77 157.65 13.77 160.74 10.66 193.25 10.66 192.6 9.51"/>
      <polygon fill="#d1a856" points="88.92 13.19 42.59 13.19 40.08 10.66 86.38 10.66 85.23 9.51 38.94 9.51 36.59 7.14 18.72 7.14 18.4 7.71 36.35 7.71 38.13 9.51 7.39 9.51 6.75 10.66 39.26 10.66 42.35 13.77 89.49 13.77 88.92 13.19"/>
    </svg>

    <!-- overview-heading-rule -->
    <svg v-if="prop(overviewHeadingRule)" class="overview-heading-rule" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="250px" height="12px">
      <path fill-rule="evenodd"  fill="rgb(208, 167, 86)" d="M249.992,9.528 L202.396,9.528 L200.509,12.003 L142.441,12.003 L139.753,9.528 L134.036,9.528 L124.999,2.160 L115.962,9.528 L110.245,9.528 L107.556,12.003 L49.489,12.003 L47.602,9.528 L0.006,9.528 L4.272,7.835 L46.311,7.835 L43.837,4.589 L47.034,7.835 L110.682,7.835 L115.188,3.778 L118.750,3.778 L117.687,4.589 L115.612,4.589 L112.085,7.835 L115.280,7.835 L124.999,0.005 L134.718,7.835 L137.913,7.835 L134.386,4.589 L132.311,4.589 L131.249,3.778 L134.810,3.778 L139.315,7.835 L202.963,7.835 L206.161,4.589 L203.687,7.835 L245.726,7.835 L249.992,9.528 ZM48.702,9.528 L50.242,11.091 L107.067,11.091 L108.802,9.528 L48.702,9.528 ZM141.196,9.528 L142.931,11.091 L199.756,11.091 L201.295,9.528 L141.196,9.528 Z"/>
    </svg>

    <!-- overview-section-end -->
    <svg v-if="prop(overviewSectionEnd)" class="overview-section-end" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 878 16">
      <path fill-rule="evenodd"  opacity="0.102" fill="rgb(247, 208, 139)" d="M877.989,12.704 L812.496,12.704 L809.901,16.004 L462.999,16.004 L459.300,12.704 L451.434,12.704 L438.998,2.881 L426.563,12.704 L418.697,12.704 L414.998,16.004 L68.096,16.004 L65.500,12.704 L0.007,12.704 L5.878,10.446 L63.724,10.446 L60.319,6.117 L64.720,10.446 L419.300,10.446 L425.498,5.039 L430.399,5.039 L428.937,6.117 L426.082,6.117 L421.229,10.446 L425.626,10.446 L438.998,0.007 L452.371,10.446 L456.768,10.446 L451.915,6.117 L449.060,6.117 L447.598,5.039 L452.499,5.039 L458.697,10.446 L813.277,10.446 L817.678,6.117 L814.272,10.446 L872.119,10.446 L877.989,12.704 ZM67.015,12.704 L69.133,14.787 L414.324,14.787 L416.711,12.704 L67.015,12.704 ZM461.286,12.704 L463.673,14.787 L808.864,14.787 L810.982,12.704 L461.286,12.704 Z"/>
    </svg>

    <!-- info icon -->
    <svg v-if="prop(iconInfo)" class="icon icon--info" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 23 23" style="enable-background:new 0 0 23 23;" xml:space="preserve">
      <path d="M11.5,0.5l11,11l-11,11l-11-11L11.5,0.5z" fill="#1E282D" stroke="#C8AA6E"/>
      <text class="icon--info-text" x="8.75" y="15.5" fill="#C8AA6E">?</text>
    </svg>

    <!-- Home icon -->
    <svg v-if="prop(iconHome)" class="icon icon--home" x="0px" y="0px" viewBox="0 0 29 37" style="enable-background:new 0 0 29 37;" xml:space="preserve" width="16px">
      <path class="st0" d="M14.5,24.4c0,0,6.5-3.3,6-13.4c-2.3,1.8-6,1.7-6,1.7s-3.7,0.1-6-1.7C8,21.1,14.5,24.4,14.5,24.4z M0.2,13.4 C0.1,12.3,0,11.2,0,10.1V9.6l2.8,1.9c1.3,0.8,2.7,1.7,4,2.4C7,15,7.2,16.2,7.5,17.3l-2.3-1.1C5.4,17,5.7,17.7,6,18.5h0 c3.8,8.8,18.7,12.3,18.7,12.3c-2.9,5.7-9.9,7.9-15.5,5c-2.1-1.1-3.9-2.8-5-5h0h0h0h0c1.6-0.4,3.1-0.9,4.7-1.5c1.1,0.6,2.8,1.5,4,2.1 c-0.8,0.3-1.7,0.7-2.6,1.1c1.3,0.8,2.7,1.2,4.1,1.2c1.5,0.1,3.1-0.3,4.4-1.2C5.3,27.5,1,20.8,0.2,13.7L0.2,13.4z M23.2,18 c-1.3,3.2-4,5.8-7,7.7c1.2,0.6,2.5,1.2,3.8,1.7c8-5.1,9.1-11.4,9.1-17.8c0,0-3.9,2.5-6.8,4.1c-0.1,1.2-0.3,2.3-0.7,3.5l2.3-1.1 C23.6,16.7,23.4,17.4,23.2,18L23.2,18z M11.2,10.6c2.2,0.5,4.4,0.5,6.6,0C15.9,9.1,18,8.5,18.5,7c0.4-1.2-0.8-2.1-2.1-3.5 S15,1.1,15.6,0c-0.9,0.5-2.2,2.2-1.7,3.4s1,2.7-0.7,2.8c-1.7,0.1-1.5-1.9-1.5-1.9S9,6.6,10.8,9.6C11,9.9,11.1,10.2,11.2,10.6 L11.2,10.6z"/>
    </svg>

    <!-- assemble icon -->
    <svg v-if="prop(iconAssemble)" class="icon icon--assemble" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 15.1 8.8" style="enable-background:new 0 0 15.1 8.8;" xml:space="preserve">
      <path d="M2.5,6.5C0.9,6.5,0,8.8,0,8.8h2.1l1-1.6l0.6-0.6C3.6,6.7,2.7,6.5,2.5,6.5z M12.6,6.5c-0.3,0-1.1-0.1-1,0.2 c0.5,0.6,0.9,1.3,1.3,2.1h2.3C15.1,8.8,14.2,6.5,12.6,6.5L12.6,6.5z M7.6,5.8C5.7,5.7,4,6.9,3.4,8.8h8.4C11.2,6.9,9.5,5.7,7.6,5.8 L7.6,5.8z M12.6,5.7c0.9,0.1,1.6-0.6,1.7-1.5c0,0,0,0,0,0c-0.1-0.9-0.8-1.5-1.7-1.5C11.8,2.7,11,3.3,11,4.2 C11,5.1,11.7,5.7,12.6,5.7L12.6,5.7z M2.5,5.7c0.9,0,1.6-0.6,1.7-1.5C4.1,3.3,3.4,2.7,2.5,2.7C1.6,2.7,0.9,3.3,0.8,4.2c0,0,0,0,0,0 C0.9,5.1,1.6,5.8,2.5,5.7C2.5,5.7,2.5,5.7,2.5,5.7z M7.7,5c1.4,0,2.5-1.1,2.6-2.4C10.2,1.1,9.1,0,7.7,0C6.3,0,5.1,1.1,5.1,2.6 C5.1,3.9,6.3,5,7.7,5L7.7,5z" fill="#676767"/>
    </svg>

    <!-- scouting icon -->
    <svg v-if="prop(iconScouting)" class="icon icon--scouting" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 14.7 9.2" style="enable-background:new 0 0 14.7 9.2;" xml:space="preserve">
      <path d="M13.6,3.7l-2.4-3l0,0C10.9,0.3,10.3,0,9.8,0c-1.1,0-2,0.8-2,1.9c0,0,0,0.1,0,0.1c0,0.2,0,0.3,0.1,0.5v0.1 c-0.2,0-0.4,0-0.5,0c-0.2,0-0.3,0-0.5,0V2.5C6.8,2.3,6.9,2.2,6.9,2C6.9,1,6.1,0.1,5,0C5,0,5,0,5,0C4.4,0,3.8,0.3,3.4,0.7l0,0L1,3.7 C0.4,4.3,0,5.2,0,6c0,1.8,1.4,3.2,3.2,3.2S6.3,7.8,6.3,6V6l0.2-1.6c0.1-0.1,0.2-0.2,0.3-0.2c0.3-0.2,0.7-0.2,1,0 c0.1,0.1,0.2,0.1,0.3,0.2L8.4,6V6c0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2c0,0,0,0,0,0C14.6,5.1,14.3,4.3,13.6,3.7z M3.2,8.1 C2,8.1,1.1,7.1,1.1,6c0-1.1,0.9-2.1,2-2.1c0,0,0.1,0,0.1,0c1.2-0.1,2.2,0.8,2.3,2S4.6,8,3.5,8.1C3.4,8.1,3.3,8.1,3.2,8.1z M11.4,8.1 c-1.2,0-2.1-1-2.1-2.1c-0.1-1.2,0.8-2.2,2-2.3c1.2-0.1,2.2,0.8,2.3,2c0,0.1,0,0.2,0,0.3C13.6,7.1,12.6,8.1,11.4,8.1 C11.5,8.1,11.5,8.1,11.4,8.1z" fill="#676767"/>
    </svg>

    <!-- champ select icon -->
    <svg v-if="prop(iconChamp)" class="icon icon--champ-select" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 10 11.4" style="enable-background:new 0 0 10 11.4;" xml:space="preserve">
      <path d="M9.3,4.3C9.3,1.1,5,0,5,0S0.7,1.1,0.7,4.3s0,3.6-0.7,4.3c0,0,1,2.9,3.6,2.9c0,0-0.7-0.7-0.7-4.3 c0,0-1.4-0.3-1.4-2.9c1.1,0,2.2,0.6,2.9,1.4v2.9L5,9.3l0.7-0.7V5.7c0.7-0.9,1.7-1.4,2.9-1.4c0,2.5-1.4,2.9-1.4,2.9 c0,3.6-0.7,4.3-0.7,4.3C9,11.4,10,8.6,10,8.6C9.2,7.8,9.3,7.4,9.3,4.3z" fill="#676767"/>
    </svg>

    <!-- bracket icon -->
    <svg v-if="prop(iconBracket)" class="icon icon--bracket" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 8.5 11.4" style="enable-background:new 0 0 8.5 11.4;" xml:space="preserve">
      <path d="M2.2,0h0.5c0.1,0,0.2,0.1,0.2,0.2v1.9c0,0.1-0.1,0.2-0.2,0.2H2.2c-0.1,0-0.2-0.1-0.2-0.2V0.2 C2.1,0.1,2.2,0,2.2,0z" fill="#676767"/>
      <polygon points="6.9,0.7 6.9,1.4 7.9,1.4 7.9,11.4 8.5,11.4 8.5,0.7" fill="#676767"/>
      <rect x="3.4" y="0.7" class="st0" width="1.8" height="0.7" fill="#676767"/>
      <polygon points="0.7,1.4 1.6,1.4 1.6,0.7 0,0.7 0,11.4 8.5,11.4 8.5,10.8 0.7,10.8 " fill="#676767"/>
      <path d="M5.8,0h0.5c0.1,0,0.2,0.1,0.2,0.2v1.9c0,0.1-0.1,0.2-0.2,0.2H5.8c-0.1,0-0.2-0.1-0.2-0.2V0.2 C5.6,0.1,5.7,0,5.8,0z" fill="#676767"/>
    </svg>

    <!-- ticket icon -->
    <svg v-if="prop(iconTicket)" class="icon icon--ticket" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 8.9 10.5" style="enable-background:new 0 0 8.9 10.5;" xml:space="preserve">
      <path d="M7.9,0H6.1L4.4,1.4L2.8,0H0v10.5h2.8l1.7-1.4l1.7,1.4h2.8V0H7.9z M7.7,2.2v7.1H6.6L4.4,7.6L2.3,9.2H1.2v-8h1.2 l2.1,1.6l2.1-1.6h1.2L7.7,2.2z" fill="#676767"/>
    </svg>

    <!-- checkbox icon -->
    <svg v-if="prop(iconCheckbox)" class="icon" xmlns="http://www.w3.org/2000/svg" width="14px" height="14px">
      <path fill-rule="evenodd"  fill="rgb(208, 167, 86)" d="M0.000,14.000 L0.000,-0.000 L11.000,-0.000 L9.000,2.000 L2.000,2.000 L2.000,12.000 L12.000,12.000 L12.000,8.000 L14.000,6.000 L14.000,14.000 L0.000,14.000 ZM8.075,8.580 L6.994,9.576 L6.496,10.044 L6.491,10.040 L6.487,10.044 L5.365,8.912 L5.082,8.629 L5.083,8.628 L2.956,6.482 L4.482,4.987 L6.628,7.133 L14.000,-0.000 L14.000,3.000 L8.065,8.571 L8.075,8.580 Z"/>
    </svg>

    <!-- swords icon -->
    <svg v-if="prop(iconSwords)" class="icon" xmlns="http://www.w3.org/2000/svg" width="16px" height="16px">
      <path fill-rule="evenodd"  fill="rgb(208, 167, 86)" d="M13.000,16.000 L9.000,12.000 L12.000,9.000 L16.000,13.000 L16.000,16.000 L13.000,16.000 ZM15.000,6.000 L13.000,8.000 L11.526,6.526 L3.000,16.000 L0.000,16.000 L0.000,13.000 L9.474,4.474 L8.000,3.000 L10.000,1.000 L11.671,2.671 L14.000,-0.000 L16.000,2.000 L13.329,4.329 L15.000,6.000 ZM1.000,6.000 L2.671,4.329 L0.000,2.000 L2.000,-0.000 L4.329,2.671 L6.000,1.000 L8.000,3.000 L3.000,8.000 L1.000,6.000 Z"/>
    </svg>

    <!-- chest icon -->
    <svg v-if="prop(iconChest)" class="icon" xmlns="http://www.w3.org/2000/svg" width="16px" height="16px">
      <path fill-rule="evenodd"  fill="rgb(208, 167, 86)" d="M15.000,16.000 L1.000,16.000 L0.000,15.000 L0.000,1.000 L1.000,-0.000 L4.000,-0.000 L12.000,-0.000 L15.000,-0.000 L16.000,1.000 L16.000,15.000 L15.000,16.000 ZM10.000,5.000 L8.000,3.000 L6.000,5.000 L6.000,7.000 L8.000,9.000 L10.000,7.000 L10.000,5.000 ZM14.000,2.000 L12.000,4.000 L12.000,8.000 L8.000,12.000 L4.000,8.000 L4.000,4.000 L2.000,2.000 L2.000,14.000 L14.000,14.000 L14.000,2.000 Z"/>
    </svg>

    <!-- clash logo -->
    <svg v-if="prop(clashLogo)" class="icon" xmlns="http://www.w3.org/2000/svg" width="114px" height="122px">
      <path fill-rule="evenodd"  opacity="0.2" fill="rgb(205, 190, 145)" d="M56.501,92.999 L56.469,92.982 L56.467,92.979 L56.465,92.979 L28.002,76.428 L32.863,39.437 C32.863,39.437 38.168,36.633 41.314,35.930 C43.605,41.136 46.296,44.543 46.296,44.543 C43.966,43.180 40.155,37.930 40.155,37.930 L34.172,40.844 L29.485,75.786 L56.501,91.155 L83.517,75.786 L78.831,40.844 L72.498,37.930 C72.498,37.930 69.035,43.180 66.706,44.543 C66.706,44.543 69.396,41.136 71.688,35.930 C74.835,36.633 80.140,39.437 80.140,39.437 L84.999,76.428 L56.501,92.999 ZM67.601,47.256 C67.601,47.256 70.895,44.322 72.832,40.867 C74.200,41.152 76.149,42.149 76.149,42.149 C76.214,55.453 66.589,62.021 62.792,64.402 C69.051,57.154 69.915,51.815 70.351,49.896 C68.760,51.201 65.652,52.414 65.652,52.414 L67.601,47.256 ZM56.920,47.326 C54.501,47.526 51.933,47.830 51.420,50.911 C50.907,53.992 52.987,57.649 52.987,57.649 C52.987,57.649 50.048,53.949 48.690,48.339 C47.332,42.729 47.704,40.190 47.704,38.604 C47.704,37.018 50.245,36.961 50.245,36.961 L50.245,37.593 C48.143,37.787 47.996,39.030 49.587,39.763 C53.590,41.605 58.657,41.262 61.622,40.438 C63.859,39.818 64.526,38.673 63.958,38.070 C63.389,37.469 62.357,37.494 62.357,37.494 C62.357,37.494 62.352,37.321 62.352,36.861 C63.904,36.861 64.937,37.521 64.937,38.537 C64.937,39.554 65.157,42.246 64.254,43.686 C62.746,46.087 59.341,47.126 56.920,47.326 ZM60.889,38.944 C60.889,38.944 59.225,39.730 57.208,39.464 C54.537,39.113 55.494,36.986 54.571,35.756 C54.839,38.121 53.670,39.133 52.754,39.093 C51.672,39.044 51.374,38.751 51.374,38.751 C51.374,38.751 52.674,38.464 52.610,36.524 C52.565,35.169 50.615,33.610 52.819,31.194 C51.455,34.529 55.017,34.552 55.416,33.059 C55.814,31.566 53.935,29.203 55.841,27.999 C54.336,30.271 57.298,30.193 58.007,33.040 C58.585,35.367 56.309,36.260 57.832,37.130 C58.452,37.483 60.774,36.687 59.280,32.980 C62.638,35.575 58.733,37.542 60.889,38.944 ZM56.379,32.160 C57.228,33.965 55.504,34.171 56.288,35.820 C56.126,34.654 57.871,33.759 56.379,32.160 ZM45.401,47.256 L47.350,52.414 C47.350,52.414 44.242,51.201 42.652,49.896 C43.087,51.815 46.165,60.328 54.719,66.921 C45.786,62.436 36.789,55.453 36.852,42.149 C36.852,42.149 38.802,41.152 40.171,40.867 C42.107,44.322 45.401,47.256 45.401,47.256 ZM47.224,65.257 C38.985,62.591 35.102,57.350 35.102,57.350 L35.704,51.888 C35.704,51.888 37.491,60.006 47.224,65.257 ZM45.293,68.578 C37.630,68.062 34.180,65.475 34.180,65.475 L34.585,61.944 C34.585,61.944 37.879,66.698 45.293,68.578 ZM48.022,82.580 L42.986,79.863 L45.187,76.617 L49.650,76.617 L48.022,82.580 ZM56.501,61.273 C56.501,61.273 54.391,59.693 53.174,55.961 C51.954,52.229 52.365,49.734 54.619,49.205 C56.510,48.763 60.271,49.556 64.193,46.712 C61.869,56.956 56.501,61.273 56.501,61.273 ZM59.376,63.857 C59.376,63.857 58.308,63.538 57.957,63.254 C61.521,60.976 63.523,57.310 63.523,57.310 C62.552,59.697 61.358,61.931 59.376,63.857 ZM63.353,76.617 L67.816,76.617 L70.015,79.863 L64.981,82.580 L63.353,76.617 ZM65.779,65.257 C75.511,60.006 77.299,51.888 77.299,51.888 L77.902,57.350 C77.902,57.350 74.018,62.591 65.779,65.257 ZM78.822,65.475 C78.822,65.475 75.372,68.062 67.709,68.578 C75.124,66.698 78.418,61.944 78.418,61.944 L78.822,65.475 ZM74.850,77.280 L71.575,79.028 L70.176,76.958 L74.436,76.958 L74.850,77.280 ZM79.381,70.361 L79.780,73.837 C74.197,74.837 69.635,74.328 64.479,73.021 C73.395,73.467 79.381,70.361 79.381,70.361 ZM60.900,74.979 L63.241,83.561 L63.079,83.645 L56.501,87.024 L49.761,83.561 L52.101,74.979 C53.726,75.462 55.208,75.639 56.501,75.646 C57.795,75.639 59.275,75.462 60.900,74.979 ZM46.355,67.661 C48.912,67.333 51.265,66.498 51.265,66.498 L53.954,68.004 L52.216,68.839 C52.216,68.839 55.626,72.529 60.539,68.642 C55.713,66.921 51.526,62.338 49.479,57.310 C49.479,57.310 53.699,65.760 66.744,67.661 C62.337,76.325 49.721,75.414 46.355,67.661 ZM41.428,79.028 L38.152,77.280 L38.566,76.958 L42.824,76.958 L41.428,79.028 ZM33.621,70.361 C33.621,70.361 39.607,73.467 48.523,73.021 C43.367,74.328 38.807,74.837 33.223,73.837 L33.621,70.361 Z"/>
    </svg>

    <!-- torch icon -->
    <svg v-if="prop(iconTorch)" class="icon icon--torch" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="19px" height="25px" viewBox="0 0 72.8 99" style="enable-background:new 0 0 72.8 99;" xml:space="preserve">
      <path class="st0" d="M36.4,65.3c0,0,16.3-8.8,15-35.8c-5.7,4.8-15,4.5-15,4.5s-9.3,0.4-15-4.5C20.1,56.5,36.4,65.3,36.4,65.3z"/>
      <path class="st0" d="M0.4,35.8C0.1,32.9,0,30,0,27.1v-1.4l7.1,5c3.2,2.1,6.9,4.4,10.1,6.3c0.3,3.1,0.9,6.2,1.7,9.2l-5.7-3 c0.4,2.1,1,4.2,1.9,6.1l0,0c9.6,23.6,47,32.8,47,32.8S54.9,99,36.4,99c-18.2,0-25.6-16.3-25.8-16.8h0.1c4-1.1,7.9-2.4,11.7-3.9 c2.7,1.7,7,4.1,10.1,5.6c-2.1,0.8-4.2,2-6.5,3c3.1,2,6.7,3.1,10.4,3.1c1.4,0,6.5,0.5,10.9-3.1C13.4,73.5,2.4,55.7,0.5,36.5L0.4,35.8 z"/>
      <path class="st0" d="M58.2,48.2c-3.2,8.7-10,15.5-17.7,20.7c3,1.7,6.2,3.2,9.4,4.6C70,59.9,72.8,43,72.8,25.7c0,0-9.8,6.6-17.2,11.1 C55.4,39.9,54.8,43,54,46l5.8-3C59,46.1,58.2,48,58.2,48.2z"/>
      <path class="st0" d="M28.1,28.4c2.7,0.8,5.5,1.1,8.3,1.1c2.8,0,5.6-0.3,8.3-1.1c-4.8-4,0.5-5.7,1.9-9.7c1.1-3.2-2-5.6-5.3-9.4 S37.6,3,39.2,0c-2.4,1.3-5.4,5.9-4.3,9s2.5,7.2-1.8,7.5s-3.8-5.2-3.8-5.2s-6.7,6.2-2.3,14.2C27.5,26.4,27.8,27.4,28.1,28.4z"/>
    </svg>

    <!-- modal close btn -->
    <svg v-if="prop(modalCloseBtn)" class="close" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="51.5px" height="50.5px">
      <path fill-rule="evenodd" stroke="rgb(200, 155, 60)" stroke-width="1px" stroke-linecap="butt" stroke-linejoin="miter" fill="rgb(12, 20, 29)" d="M25.493,0.487 L50.498,25.000 L25.493,49.513 L0.487,25.000 L25.493,0.487 Z"/>
      <path fill-rule="evenodd" fill="rgb(240, 230, 210)" d="M30.513,28.083 L29.083,29.512 L25.493,25.922 L21.964,29.450 L20.550,28.036 L24.078,24.507 L20.488,20.917 L21.917,19.488 L25.507,23.078 L29.035,19.550 L30.450,20.965 L26.922,24.493 L30.513,28.083 Z"/>
    </svg>

    <svg v-if="prop(tooltipBracket)" class="tool-tip-bracket" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 6.4 30.4" style="enable-background:new 0 0 6.4 30.4;" xml:space="preserve">
      <path d="M5.9,1.2l-2,2v10l-2,2l2,2v10l2,2"/>
    </svg>

  </div>
</template>

<script>
export default {
  name: 'SvgLib',
  data () {
    return {}
  },
  props: [
    'clashLogo',
    'angleRight',
    'iconRuleLines',
    'iconRuleLinesBottom',
    'iconInfo',
    'iconScouting',
    'iconChamp',
    'iconBracket',
    'iconAssemble',
    'modalCloseBtn',
    'iconHome',
    'iconTicket',
    'overviewHeadingRule',
    'overviewSubheadRule',
    'overviewSectionEnd',
    'iconCheckbox',
    'iconSwords',
    'iconChest',
    'iconTorch',
    'tooltipBracket'
  ],
  methods: {
    prop (val) {
      return val !== undefined
    }
  }
}
</script>

<style lang="scss">
  @import "../styles/global/the_goods";

  .icon {

    &--assemble {
      height : 1.5rem;
      width  : 1.8rem;
    }

    &--scouting {
      height : 1.5rem;
      width  : 1.6rem;
    }

    &--home,
    &--champ-select,
    &--bracket {
      height : 2rem;
      width  : 1.3rem;
    }

    &--ticket {
      height : 2rem;
      width  : 1.2rem;
    }

    &--info {
      width : 2.5rem;

      &:hover {
        cursor: pointer;
      }

      &-text {
        font-size : 1.15rem;
        @include beaufort;
        @include media-breakpoint-up(xxl) {
          font-size : 0.9rem;
        }
        @include media-breakpoint-up(xxl) {
          font-size : 0.8rem;
        }
      }
    }
  }

  .icon-rule-lines {
    width: 39.7rem;
    height: 2.7rem;

    @include media-breakpoint-down(sm) {
      width: 35rem;
    }

    &--bottom {
      width: 26.4rem;
      height: 1.6rem;
    }
  }

  .icon-rule,
  .subhead-rule {
    position : relative;

    .icon {
      position  : absolute;
      top       : 0;
      left      : 50%;
      transform : translateX(-50%);
      fill      : $gold2;

      &--assemble,
      &--scouting {
        width : 2rem;
        top   : 0.4rem;
      }

      path, rect, polygon {
        fill : $gold2;
      }
    }

    &--large {
      margin-bottom: 0.7rem;

      .icon--assemble {
        height : 1.6rem;
        width  : 2.3rem;
        top    : 0.2rem;
      }

      .icon--scouting {
        height : 1.8rem;
        width  : 2.2rem;
        top    : 0.2rem;
      }

      .icon--day-one {
        height : 2.4rem;
        width  : 2rem;
        top    : -0.3rem;
      }
    }
  }

  .subhead-rule {
    .icon {
      transform: translateX(-50%) scale(0.8);
    }
  }

  .overview-section-end {
    width: 100%;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/SvgLib.vue